// extracted by mini-css-extract-plugin
export default {"main":"WhyLodestone_main__uI9Tn","swiperCont":"WhyLodestone_swiperCont__qO7ru","box":"WhyLodestone_box__lwtW3","head":"WhyLodestone_head__cYSsS"};